// @flow
import BidConsoleOpener from '../../components/BidConsoleOpener/BidConsoleOpener';
import CatalogDate from '../../components/CatalogDate/CatalogDate';
import FormattedCurrencyContainer from '../../components/Formatted/FormattedCurrencyContainer';
import { FormattedMessage } from 'react-intl';
import { getSellerUrl } from '../../utils/urls';
import Link from '@liveauctioneers/caterwaul-components/lib/Link/Link';
import React from 'react';
import { safelyRender } from '../../utils/safelyRender';
import { shouldShowLive } from '../../utils/live';
import styles from './DetailsRow.module.scss';

type Props = {
    allowBidding: boolean,
    buyNowStatus: string,
    catalogId: number,
    catalogStatus: string,
    comingUp: boolean,
    currency: string,
    currentItemIndex: number,
    hideLiveButton: boolean,
    hideSeller: boolean,
    highBidEstimate: number,
    index: number,
    isCatalogOnly: boolean,
    lowBidEstimate: number,
    saleStartTs: number,
    sellerId: number,
    sellerName: string,
    showDate: boolean,
    showEstimate: boolean,
};

const DetailsRow = (props: Props) => {
    const {
        allowBidding,
        buyNowStatus,
        catalogId,
        catalogStatus,
        comingUp,
        currency = 'usd',
        currentItemIndex,
        hideLiveButton,
        hideSeller,
        highBidEstimate = 0,
        index,
        isCatalogOnly,
        lowBidEstimate = 0,
        saleStartTs,
        sellerId,
        sellerName,
        showDate,
        showEstimate,
    } = props;

    const safeSellerName = safelyRender(sellerName, 'span');

    const estimateRange = {
        high: <FormattedCurrencyContainer value={highBidEstimate} sourceCurrency={currency} noFraction />,
        low: <FormattedCurrencyContainer value={lowBidEstimate} sourceCurrency={currency} noFraction />,
    };

    const showLiveButton = shouldShowLive(catalogStatus, isCatalogOnly, saleStartTs);
    const buyNowAvailable = buyNowStatus === 'available' && catalogStatus === 'done';
    const lotsAway = index - currentItemIndex;

    return (
        <div className={styles['estimate-house-time-container']}>
            {showEstimate && (
                <div className={styles['estimate-link-container']}>
                    <span className={styles['estimate-name-container']}>
                        <FormattedMessage id="short_estimate_values" values={estimateRange} />
                    </span>
                </div>
            )}
            {!hideSeller && (
                <div className={styles['auctioneer-link-container']}>
                    <span className={styles['auctioneer-name-container']}>
                        {sellerName ? (
                            <Link
                                className={styles['auctioneer-link']}
                                route
                                to={getSellerUrl(sellerId, sellerName)}
                                primaryWeak
                            >
                                {safeSellerName}
                            </Link>
                        ) : (
                            <span className={styles['auctioneer-link']}>Jasper52</span>
                        )}
                    </span>
                </div>
            )}
            {!hideLiveButton && (
                <div className={styles['catalog-countdown-container']}>
                    {buyNowAvailable ? null : showLiveButton && comingUp ? (
                        <span className={styles['item-is-live']}>
                            <BidConsoleOpener catalogId={catalogId} sellerId={sellerId}>
                                <span className={styles['item-is-live-link']}>
                                    {lotsAway > 0 && allowBidding ? (
                                        lotsAway === 1 && allowBidding ? (
                                            <FormattedMessage id="itemBidding.lotAway_short" />
                                        ) : (
                                            <FormattedMessage id="itemBidding.lotsAway_short" values={{ lotsAway }} />
                                        )
                                    ) : (
                                        <FormattedMessage id="bid_live" />
                                    )}
                                </span>
                            </BidConsoleOpener>
                        </span>
                    ) : (
                        <CatalogDate
                            date={saleStartTs}
                            showDate={showDate}
                            forceYear={catalogStatus === 'done' || (catalogStatus === 'live' && !comingUp)}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default React.memo<Props>(DetailsRow);
